import React, {Component} from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export default class NewUserRoomManager extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newUserRooms: [],
            loading: false,
        }

        this.fetchData = this.fetchData.bind(this);
        this.deleteRoom = this.deleteRoom.bind(this);
        this.addNewRoom = this.addNewRoom.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        this.setState({ loading: true });
        console.log(global.config.apiDomain + '/mc-live-room/web/new-user-room/get-all');
        axios.post(global.config.apiDomain + '/mc-live-room/web/new-user-room/get-all')
        .then(res => {
            let data = res.data;
            this.setState({
                newUserRooms: data.data || [],
                loading: false
            })
        }).catch(error => {
            console.error('Error fetching data:', error);
            this.setState({ loading: false });
        });
    }

    deleteRoom(roomId) {
        if (window.confirm('Bạn có chắc chắn muốn xóa phòng này?')) {
            axios.post(global.config.apiDomain + '/mc-live-room/web/new-user-room/delete/' + roomId, {
            }).then(res => {
                if (res.data.status === 'OK') {
                    toast.success('Xóa phòng thành công!');
                    // Reload danh sách ngay lập tức
                    this.fetchData();
                } else {
                    toast.error('Xóa phòng thất bại: ' + res.data.message);
                }
            }).catch(error => {
                console.error('Error deleting room:', error);
                toast.error('Có lỗi xảy ra khi xóa phòng!');
            });
        }
    }

    addNewRoom() {
        const roomId = prompt('Nhập ID phòng live new user:');
        if (roomId && roomId.trim()) {
            axios.post(global.config.apiDomain + '/mc-live-room/web/new-user-room/add/' + roomId).then(res => {
                if (res.data.status === 'OK') {
                    toast.success('Thêm phòng thành công!');
                    // Reload danh sách ngay lập tức
                    this.fetchData();
                } else {
                    toast.error('Thêm phòng thất bại: ' + res.data.message);
                }
            }).catch(error => {
                console.error('Error adding room:', error);
                toast.error('Có lỗi xảy ra khi thêm phòng!');
            });
        }
    }

    render() {
        const {newUserRooms, loading} = this.state;
        console.log(newUserRooms);

        return (
            <>
                <div id="content">
                    <div className="container-fluid">
                        <h1 className="text-center">Quản lí phòng New User</h1>
                        <div className="row">
                            <div className="col-12">
                                <div className="card" style={{
                                    border: 'none',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                    marginTop: '20px'
                                }}>
                                    <div className="card-body">
                                        <div style={{ 
                                            display: 'flex', 
                                            justifyContent: 'space-between', 
                                            alignItems: 'center', 
                                            marginBottom: '20px' 
                                        }}>
                                            <h5 style={{ 
                                                margin: 0, 
                                                color: '#2c3e50', 
                                                fontWeight: '600' 
                                            }}>
                                                Danh sách phòng New User
                                            </h5>
                                            <button 
                                                className="btn btn-success"
                                                style={{
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    padding: '10px 20px',
                                                    fontWeight: '500',
                                                    boxShadow: '0 2px 8px rgba(40, 167, 69, 0.2)',
                                                    transition: 'all 0.3s ease',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                                onMouseOver={(e) => {
                                                    e.target.style.transform = 'translateY(-2px)';
                                                    e.target.style.boxShadow = '0 4px 12px rgba(40, 167, 69, 0.3)';
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.transform = 'translateY(0)';
                                                    e.target.style.boxShadow = '0 2px 8px rgba(40, 167, 69, 0.2)';
                                                }}
                                                onClick={this.addNewRoom}
                                            >
                                                <i className="fas fa-plus" style={{ marginRight: '8px' }}></i>
                                                Thêm phòng mới
                                            </button>
                                        </div>
                                        <div className="table-responsive">
                                            {loading ? (
                                                <div style={{ 
                                                    textAlign: 'center', 
                                                    padding: '40px',
                                                    color: '#6c757d'
                                                }}>
                                                    <i className="fas fa-spinner fa-spin" style={{ 
                                                        fontSize: '24px', 
                                                        marginRight: '10px' 
                                                    }}></i>
                                                    Đang tải dữ liệu...
                                                </div>
                                            ) : (
                                                <table className="table table-hover">
                                                <thead style={{ backgroundColor: '#f8f9fa' }}>
                                                    <tr>
                                                        <th style={{ fontWeight: '600', color: '#2c3e50' }}>ID</th>
                                                        <th style={{ fontWeight: '600', color: '#2c3e50' }}>Tên phòng</th>
                                                        <th style={{ fontWeight: '600', color: '#2c3e50' }}>UID</th>
                                                        <th style={{ fontWeight: '600', color: '#2c3e50' }}>Số người online</th>
                                                        <th style={{ fontWeight: '600', color: '#2c3e50' }}>Thao tác</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {newUserRooms.length > 0 ? (
                                                        newUserRooms.map((room, index) => (
                                                            <tr key={room.id} style={{ borderBottom: '1px solid #e9ecef' }}>
                                                                <td style={{ padding: '12px', verticalAlign: 'middle' }}>
                                                                    <span style={{ 
                                                                        backgroundColor: '#e3f2fd', 
                                                                        color: '#1976d2', 
                                                                        padding: '4px 8px', 
                                                                        borderRadius: '4px',
                                                                        fontSize: '15px',
                                                                        fontWeight: '500'
                                                                    }}>
                                                                        {room.id}
                                                                    </span>
                                                                </td>
                                                                <td style={{ padding: '12px', verticalAlign: 'middle' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        {room.thumbnail && (
                                                                            <img 
                                                                                src={room.thumbnail} 
                                                                                alt="Avatar" 
                                                                                style={{ 
                                                                                    width: '32px', 
                                                                                    height: '32px', 
                                                                                    borderRadius: '50%', 
                                                                                    marginRight: '10px',
                                                                                    objectFit: 'cover'
                                                                                }} 
                                                                            />
                                                                        )}
                                                                        <div>
                                                                            <div style={{ fontWeight: '500', color: '#2c3e50' }}>
                                                                                {room.name || room.simplifiedName}
                                                                            </div>
                                                                            <small style={{ color: '#6c757d' }}>
                                                                                {room.kind} • {room.language}
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td style={{ padding: '12px', verticalAlign: 'middle' }}>
                                                                    <span style={{ 
                                                                        backgroundColor: '#f8f9fa', 
                                                                        color: '#495057', 
                                                                        padding: '4px 8px', 
                                                                        borderRadius: '4px',
                                                                        fontSize: '15px',
                                                                        fontWeight: '500'
                                                                    }}>
                                                                        {room.uid}
                                                                    </span>
                                                                </td>
                                                                <td style={{ padding: '12px', verticalAlign: 'middle' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <i className="fas fa-users" style={{ 
                                                                            color: room.noOnlineMembers > 0 ? '#28a745' : '#6c757d', 
                                                                            marginRight: '6px' 
                                                                        }}></i>
                                                                        <span style={{ 
                                                                            color: room.noOnlineMembers > 0 ? '#28a745' : '#6c757d',
                                                                            fontWeight: '500'
                                                                        }}>
                                                                            {room.noOnlineMembers || 0}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                                <td style={{ padding: '12px', verticalAlign: 'middle' }}>
                                                                    <button 
                                                                        className="btn btn-danger btn-sm"
                                                                        style={{
                                                                            border: 'none',
                                                                            borderRadius: '6px',
                                                                            padding: '6px 12px',
                                                                            fontSize: '12px',
                                                                            fontWeight: '500',
                                                                            boxShadow: '0 2px 4px rgba(220, 53, 69, 0.2)',
                                                                            transition: 'all 0.3s ease'
                                                                        }}
                                                                        onMouseOver={(e) => {
                                                                            e.target.style.transform = 'translateY(-1px)';
                                                                            e.target.style.boxShadow = '0 4px 8px rgba(220, 53, 69, 0.3)';
                                                                        }}
                                                                        onMouseOut={(e) => {
                                                                            e.target.style.transform = 'translateY(0)';
                                                                            e.target.style.boxShadow = '0 2px 4px rgba(220, 53, 69, 0.2)';
                                                                        }}
                                                                        onClick={() => this.deleteRoom(room.id)}
                                                                    >
                                                                        <i className="fas fa-trash" style={{ marginRight: '4px' }}></i>
                                                                        Xóa
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" style={{ 
                                                                textAlign: 'center', 
                                                                padding: '40px', 
                                                                color: '#6c757d',
                                                                fontStyle: 'italic'
                                                            }}>
                                                                Không có phòng new user nào
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}